import { useEffect } from "react";
import { act } from "../net/rally.ts";

const readers = new Set<() => void>();

function tellThePage(): void {
  for (const reader of [...readers]) reader();
}

export async function markRead(conversation: string): Promise<void> {
  try {
    await act("attention.read", { conversation });
    tellThePage();
  } catch {}
}

export function useSeen(told: () => void): void {
  useEffect(() => {
    readers.add(told);
    return () => {
      readers.delete(told);
    };
  }, [told]);
}
